import { BaseService } from "./BaseService";
import { Measures } from "../types/app.interfaces";
import { FunctionGroup, MeasuresType } from "../types/app.enums";

export class CfarService extends BaseService {
  BurgissCalcCFaR(
    investId?: any[][],
    idType?: string,
    analysisDate?: any,
    currency?: any,
    selectionSetID?: any,
    filter?: any,
    horizonQtrs?: any,
    sampleStatistic?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    minSampleSize?: any,
    maxDroppedPeriods?: any,
    bMUWindowEndDate?: any,
    bMUHistoricalWindowLengthQtrs?: any,
    maxAgeDiffYears?: any,
    stopOn?: any,
    alternatebasecurrrency?: any,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        analysisDate,
        idType,
        selectionSetID,
        filter,
        horizonQtrs,
        sampleStatistic,
        numSimulations,
        desiredSampleSize,
        minSampleSize,
        maxDroppedPeriods,
        bMUWindowEndDate,
        bMUHistoricalWindowLengthQtrs,
        maxAgeDiffYears,
        stopOn,
        MeasuresType.Unfunded,
        investId,
        [],
        currency,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcCFaR", objRequest, this.APICONFIG.GETQANALYSIS, FunctionGroup.Cfar);
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        analysisDate,
        idType,
        selectionSetID,
        filter,
        horizonQtrs,
        sampleStatistic,
        numSimulations,
        desiredSampleSize,
        minSampleSize,
        maxDroppedPeriods,
        bMUWindowEndDate,
        bMUHistoricalWindowLengthQtrs,
        maxAgeDiffYears,
        stopOn,
        MeasuresType.Unfunded,
        [],
        [],
        currency,
        alternatebasecurrrency
      );

      return super._pushOperation("BurgissCalcCFaR", objRequest, this.APICONFIG.GETQANALYSIS, FunctionGroup.Cfar);
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        analysisDate,
        idType,
        selectionSetID,
        filter,
        horizonQtrs,
        sampleStatistic,
        numSimulations,
        desiredSampleSize,
        minSampleSize,
        maxDroppedPeriods,
        bMUWindowEndDate,
        bMUHistoricalWindowLengthQtrs,
        maxAgeDiffYears,
        stopOn,
        MeasuresType.Unfunded,
        [],
        investId,
        currency,
        alternatebasecurrrency
      );

      return super._pushOperation("BurgissCalcCFaR", objRequest, this.APICONFIG.GETQANALYSIS, FunctionGroup.Cfar);
    }
    return null;
  }

  createPayload(
    alias: string = null,
    investId: any[][] = null,
    endDate: any = null,
    idType: string = null,
    selectionSetId: any = null,
    filter: any = "",
    horizonQt: any = null,
    sampleStatistic: any = null,
    numSimulations: any = null,
    desiredSampleSize: any = 0,
    minSampleSize: any = null,
    maxDroppedPeriods: any = null,
    bMUEndQuarter: any = null,
    bMUHistoricalWindowLengthQtrs: number = null,
    maxAgeDiffYears: any = null,
    stopOn: any = null,
    measure: string = null,
    portfolioId: any[][] = null,
    assetId: any[][] = null,
    currency: any = null,
    alternatebasecurrrency: any = null
  ) {
    const measuresObject: Measures = {
      excludeBalanceSheetItems: false,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: null,
      percentile: null,
      currency: null,
      returnConstituentCount: false,
      investmentID: String(investId).toUpperCase() == "ALL" ? "-1" : String(investId),
      portfolioID: String(portfolioId).toUpperCase() == "ALL" ? "-1" : String(portfolioId),
      isHoldingCalc: false,
      returnPooledResult: true,
      baseCurrency: String(currency).toLowerCase() === "true",
      alternateBaseCurrency: alternatebasecurrrency,
      adjustToMostRecent: false,
      measure: measure,
      beginDate: null,
      endDate: endDate,
      year: null,
      indexID: null,
      premium: null,
      idType: idType,
      selectionsetID: selectionSetId,
      assetID: String(assetId).toUpperCase() == "ALL" ? "-1" : String(assetId),
      weightingMethod: null,
      value: null,
      filter: filter,
      attributeName: null,
      rankValue: null,
      bMUHistoricalWindowLengthQtrs: Number(bMUHistoricalWindowLengthQtrs),
      maxAgeDiffYears: Number(maxAgeDiffYears),
      horizon: Number(horizonQt),
      maxDroppedPeriods: Number(maxDroppedPeriods),
      lastHistoricalEOQDate: bMUEndQuarter,
      numSimulations: Number(numSimulations),
      desiredSampleSize: Number(desiredSampleSize),
      minSampleSize: Number(minSampleSize),
      sampleStatistic: sampleStatistic,
      stopOn: stopOn,
      requireReportedValuation: 0,
      alias: alias,
      currencyHedgesetId: "",
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: false,
      dynamicParameter: null,
      universe: null,
      weight: null,
      commitment: null,
    };
    return measuresObject;
  }
}
